<template>
  <input v-model="localValue" :max="applyRange ? max: null" :min="applyRange ? min: null" :placeholder="placeholder"
         :readonly="readonly" :type="type" class="form-control" :step="step" @blur="updateValue" v-if="!lazy">
  <input v-model.lazy="localValue" :max="applyRange ? max: null" :min="applyRange ? min: null" :placeholder="placeholder"
         :readonly="readonly" :type="type" class="form-control" :step="step" @blur="updateValue"  v-debounce:1000ms="debFunc" v-else>
</template>

<script>
export default {
  name: 'o-input-percentage-control',
  props: {
    value: {
      default: null
    },
    type: {
      type: String,
      default: 'number'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    multiplication: {
      type: Number,
      default: 100
    },
    applyRange: {
      type: Boolean,
      default: true
    },
    step: {
      type: Number,
      default: 0.01
    },
    onlyInteger: {
      type: Boolean,
      default: true
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localValue: ''
  }),

  mounted () {
    const value = this.inRound(this.value)
    this.localValue = this.inRangValue(value)
  },

  components: {},

  watch: {
    value (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.localValue = this.inRound(newVal)
      }
    },
    localValue (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('input', newVal ? newVal / this.multiplication : null)
      }
    }
  },

  methods: {
    inRangValue (value) {
      if (!value) {
        return null
      }

      if (this.applyRange) {
        if (this.min > value) {
          value = this.min
        } else if (this.max < value) {
          value = this.max
        }
      }
      return value
    },
    inRound (value) {
      if (!value) {
        return null
      }

      if (!this.onlyInteger) {
        /* Let's keep it for revison to avoid issue with 2.2, 4.4, 6.6....etc, like 2.199999 */
        // return (value * this.multiplication * 100) / 100
        // return (Math.round(value * this.multiplication * 100) / 100).toFixed(2)
        if(this.lazy) {
          return (Math.round(value * this.multiplication * 100) / 100).toFixed(2)
        }
      }

      return Math.round(value * this.multiplication * 100) / 100
    },
    updateValue () {
      this.localValue = this.inRangValue(this.localValue)
    },
    debFunc (val, e) {
      if(val) {
        let newNumber = parseFloat(val.replace(/[^\d\.]/g, ""))
        let number = parseFloat(newNumber).toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1’")
        if (number === 'NaN') {
          number = null
        }
        this.localValue = number
        this.updateValue()
      }
    }
  }
}
</script>
